import { type ReactNode } from 'react';
import { Context } from './Context.ts';
import { useAncestors } from './hooks.ts';

export type Props = {
  ancestor: string;
  children: ReactNode;
};

export const Provider = ({ ancestor, children }: Props) => {
  const existingAncestors = useAncestors();
  return <Context.Provider value={[...existingAncestors, ancestor]}>{children}</Context.Provider>;
};
